const Footer = () => {
    return (
        <div className="p py-10">
            <p className="font-bold font-mono text-xl italic text-slate-600"><span>fashion</span> commerce 2022</p>
        </div>
    );
}
 
export default Footer;